<script setup lang="ts">
import { ref, watch } from 'vue'

const expanded = ref(false)
const props = defineProps({
  icon: {
    type: String,
    required: true
  },
  text: {
    type: String,
    required: true
  },
  iconClass: {
    type: String,
    default: 'material-symbols-outlined'
  },
  close: {
    type: Boolean,
    default: false
  }
})

watch(
  () => props.close,
  (value) => {
    if (value) {
      expanded.value = false
    }
  }
)
</script>

<template>
  <div>
    <div class="side-menu-item" @click="expanded = !expanded">
      <span draggable="false" :class="iconClass">{{ icon }}</span>
      <span>{{ text }}</span>
      <span draggable="false" class="material-symbols-outlined expand-button" :class="{ active: expanded }"> expand_more </span>
    </div>
    <div class="expandable-list" :class="{ active: expanded }">
      <slot></slot>
    </div>
  </div>
</template>

<style scoped lang="scss">
@import '@/assets/styles/sidemenu.scss';
</style>
